module.exports = "/_next/static/images/game-1-phone-gallery-08-27-1730-f1959cb4aceed787267d4a9f4144041f.jpg";